"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InstoreCashPaymentForm;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _formik = require("formik");
var Yup = _interopRequireWildcard(require("yup"));
var _content = require("@sart/content");
var _TextInputExtended = _interopRequireDefault(require("./TextInputExtended"));
var _Button = _interopRequireDefault(require("./Button"));
var _Space = _interopRequireDefault(require("./Space"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import PropTypes from 'prop-types'
var cheatsheetValues = {
  recieptNumber: 'ABCD1234'
};
function InstoreCashPaymentForm(props) {
  var onInstoreCashSubmit = props.onInstoreCashSubmit,
    initialValues = props.initialValues,
    storedPayment = props.storedPayment,
    allowCheat = props.allowCheat,
    style = props.style,
    labelStyle = props.labelStyle,
    titleStyle = props.titleStyle,
    disabledStyle = props.disabledStyle,
    enabledStyle = props.enabledStyle,
    injectedContent = props.injectedContent;
  var schema = props.schema;
  var content = injectedContent === undefined ? (0, _content.useContent)() : injectedContent;
  if (!schema) {
    schema = Yup.object().shape({
      recieptNumber: Yup.string(),
      amount: Yup.number()
    });
  }
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    autofilled = _React$useState2[0],
    setautoFilled = _React$useState2[1];
  var formik = (0, _formik.useFormik)({
    initialValues: _objectSpread({}, initialValues),
    validationSchema: schema,
    onSubmit: function onSubmit(values, form) {
      onInstoreCashSubmit(values, form);
    }
  });
  _react["default"].useEffect(function () {
    if (storedPayment) {
      formik.setValues(_objectSpread(_objectSpread({}, storedPayment), {}, {
        store: true
      }), false);
      setautoFilled(true);
    }
  }, []);
  function handleAutofillCheat() {
    formik.setValues(_objectSpread(_objectSpread({}, cheatsheetValues), {}, {
      store: formik.initialValues.store
    }), false); // should not validate
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"]
  // ref={numberRef}
  , (0, _extends2["default"])({
    label: content.forms.payAmountLabel,
    value: formik.values.amount,
    placeholder: content.forms.payAmountPlaceholder,
    error: formik.touched.amount && formik.errors.amount
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-amount"
    },
    ios: {
      keyboardType: "amount-pad"
    },
    android: {
      keyboardType: "amount-pad"
    }
  }), {
    onChangeText: formik.handleChange('amount'),
    onBlur: formik.handleBlur('amount'),
    disabled: autofilled
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: "Reciept Number",
    value: formik.values.recieptNumber,
    keyboardType: "default"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-recieptNumber"
    },
    android: {
      autoCompleteType: "recieptNumber"
    }
  }), {
    onChangeText: formik.handleChange('recieptNumber'),
    onBlur: formik.handleBlur('recieptNumber'),
    disabled: autofilled,
    style: style,
    labelStyle: labelStyle
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    title: formik.isSubmitting ? content.common.submitting : content.common.submit,
    disabled: !formik.isValid || formik.isSubmitting,
    onPress: formik.handleSubmit
  }, allowCheat && {
    onLongPress: handleAutofillCheat
  }, style && {
    style: enabledStyle,
    disabledStyle: disabledStyle
  }, {
    titleStyle: titleStyle
  })));
}
InstoreCashPaymentForm.defaultProps = {
  allowCheat: process.env.NODE_ENV === "development"
};
var styles = _reactNative.StyleSheet.create({
  // container: {},
  dateandcvv: {
    flexDirection: 'row'
  },
  inputs: {
    flex: 0.5
  },
  errormessage: {
    textAlign: 'left'
  },
  // button: {
  //   backgroundColor:colors.white
  // },
  centered: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  }
});